import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";
import { PlanoAcao } from "../models/plano-acao.model";
import { Observable } from "rxjs";

@Injectable()
export class IndicadoresAtividadeService extends BaseService<PlanoAcao>{

  constructor(public http: HttpClient) {
    super(http);
  }

  public salvarOrdem(obj: any[]): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/salvar-ordem', obj, { headers: this.headers });
  }

  public solicitarNovaSituacao(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/nova-situacao/' + id, { headers: this.headers });
  }

  public getByIdSimple(id: number): Observable<PlanoAcao> {
    return this.http.get<PlanoAcao>(this.baseUrl + '/simplificada/' + id, { headers: this.headers });
  }

  public getByIdList(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-edit', { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/atividade';
  }

}